// extracted by mini-css-extract-plugin
export default {"root":"classes_root__PEZx-","container":"classes_container__kOD2Y","title":"classes_title__qk7f7","username":"classes_username__8UeJ4"};